/* Coria campaign calendar: absolute deadlines, Europe/Bucharest, no visitor reset. */
(function(root){
  'use strict';
  var ZONE='Europe/Bucharest';
  function parse(value){
    var text=String(value||'').trim();
    var m=/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})?$/.exec(text);
    if(!m)return {error:'Folosește AAAA-LL-ZZ HH:MM, de exemplu 2026-10-16 00:00.'};
    var y=+m[1],mo=+m[2],d=+m[3],h=+m[4],mi=+m[5],sec=+(m[6]||0);
    var base=Date.UTC(y,mo-1,d,h,mi,sec),check=new Date(base);
    if(y<2000||y>2199||mo<1||mo>12||d<1||h>23||mi>59||sec>59||check.getUTCMonth()!==mo-1||check.getUTCDate()!==d)return {error:'Data sau ora nu este validă.'};
    if(m[7]){
      var suffix=m[7],offset=0;
      if(suffix!=='Z'){var hh=+suffix.slice(1,3),mm=+suffix.slice(4,6);if(hh>14||mm>59||(hh===14&&mm))return {error:'Fus orar invalid.'};offset=(hh*60+mm)*(suffix[0]==='-'?-1:1);}
      return {time:base-offset*60000};
    }
    try{
      var fmt=new Intl.DateTimeFormat('en-GB',{timeZone:ZONE,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
      var matches=[];
      [120,180].forEach(function(offset){var stamp=base-offset*60000,parts={};fmt.formatToParts(new Date(stamp)).forEach(function(p){parts[p.type]=p.value;});if(+parts.year===y&&+parts.month===mo&&+parts.day===d&&+parts.hour===h&&+parts.minute===mi&&+parts.second===sec)matches.push(stamp);});
      if(matches.length===1)return {time:matches[0]};
      return {error:matches.length?'Ora apare de două ori la schimbarea orei. Adaugă +03:00 sau +02:00 la dată.':'Ora nu există în București la schimbarea orei. Alege altă oră.'};
    }catch(_){return {error:'Fusul Europe/Bucharest nu este disponibil. Adaugă un offset explicit, de exemplu +03:00.'};}
  }
  function compile(cfg){
    if(!cfg.saleEnabled)return {enabled:false};
    if(cfg.saleMode!=='scheduled')return {enabled:true,mode:'manual'};
    var start=parse(cfg.saleStart);if(start.error)return {error:'Început: '+start.error};
    var end;
    if(cfg.saleEndMode==='duration'){
      var hours=Number(cfg.saleDurationHours);
      if(!Number.isFinite(hours)||hours<=0||hours>8760)return {error:'Durata trebuie să fie mai mare de 0 și cel mult 8760 de ore.'};
      end={time:start.time+hours*3600000};
    }else end=parse(cfg.saleEnd);
    if(end.error)return {error:'Sfârșit: '+end.error};
    if(end.time<=start.time)return {error:'Sfârșitul trebuie să fie după începutul campaniei.'};
    return {enabled:true,mode:'scheduled',start:start.time,end:end.time,teaser:!!cfg.saleTeaser};
  }
  function state(plan,now){
    if(plan.error)return {phase:'invalid',active:false,visible:false,error:plan.error};
    if(!plan.enabled)return {phase:'off',active:false,visible:false};
    if(plan.mode==='manual')return {phase:'active',active:true,visible:true,remaining:null};
    if(now<plan.start)return {phase:'upcoming',active:false,visible:plan.teaser,remaining:plan.start-now,deadline:plan.start};
    if(now>=plan.end)return {phase:'ended',active:false,visible:false,remaining:0,deadline:plan.end};
    return {phase:'active',active:true,visible:true,remaining:plan.end-now,deadline:plan.end};
  }
  function countdown(ms){var t=Math.max(0,Math.ceil(ms/1000));var d=Math.floor(t/86400),h=Math.floor(t%86400/3600),m=Math.floor(t%3600/60),s=t%60;return {days:d,hours:h,minutes:m,seconds:s,text:(d?d+'z ':'')+String(h).padStart(2,'0')+':'+String(m).padStart(2,'0')+':'+String(s).padStart(2,'0')};}
  root.CoriaCampaign={parse:parse,compile:compile,state:state,countdown:countdown};
})(typeof window!=='undefined'?window:globalThis);
